// Onthoudt welke templates (meeting types) het laatst zijn gekozen bij het
// aanmaken van een verslag, zodat de template-kiezer ze bovenaan kan tonen.
export const RECENT_TEMPLATES_KEY = 'notizy_recent_templates';
const MAX_RECENT_TEMPLATES = 5;

export const getRecentTemplateNames = (): string[] => {
    if (typeof window === 'undefined') {
        return [];
    }

    try {
        const raw = window.localStorage.getItem(RECENT_TEMPLATES_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
    } catch {
        return [];
    }
};

export const rememberRecentTemplate = (name: string): void => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        const next = [name, ...getRecentTemplateNames().filter(n => n !== name)].slice(0, MAX_RECENT_TEMPLATES);
        window.localStorage.setItem(RECENT_TEMPLATES_KEY, JSON.stringify(next));
    } catch {
        // Quota vol of private mode — recent-lijst is nice-to-have, stil negeren.
    }
};
